import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">Get In Touch.</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <p className="text-xl text-gray-300 mb-8">
              Ready to enhance your natural beauty with premium skincare and expert makeup services? 
              Located at Whitesand Beach Estate Ologolo, we're here to help you achieve your beauty goals 
              with professional excellence and personalized care.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-8">
            <div>
              <h5 className="text-lg font-semibold mb-4">Follow Us</h5>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#0" className="hover:text-white transition-colors">Instagram</a></li>
                <li><a href="#0" className="hover:text-white transition-colors">Facebook</a></li>
                <li><a href="#0" className="hover:text-white transition-colors">WhatsApp</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-semibold mb-4">Contact Info</h5>
              <ul className="space-y-2 text-gray-300">
                <li><a href="tel:09037433407" className="hover:text-white transition-colors">09037433407</a></li>
                <li><a href="tel:09014738297" className="hover:text-white transition-colors">09014738297</a></li>
                <li className="text-sm">Whitesand Beach Estate<br />Ologolo</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 mb-12">
          <a 
            href="tel:09037433407" 
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-center font-semibold hover:bg-gray-100 transition-colors"
          >
            Book a Consultation
          </a>
          <a 
            href="#works" 
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-center font-semibold hover:bg-white hover:text-gray-900 transition-colors"
          >
            View Services
          </a>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-6 mb-4 md:mb-0">
              <a href="#0" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                </svg>
              </a>
              <a href="#0" className="text-gray-400 hover:text-white transition-colors">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.998 12c0-6.628-5.372-12-11.999-12C5.372 0 0 5.372 0 12c0 5.988 4.388 10.952 10.124 11.852v-8.384H7.078v-3.469h3.046V9.356c0-3.008 1.792-4.669 4.532-4.669 1.313 0 2.686.234 2.686.234v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12h3.328l-.532 3.469h-2.796v8.384c5.736-.9 10.124-5.864 10.124-11.853z"/>
                </svg>
              </a>
            </div>
            
            <div className="text-center text-gray-400">
              <p>© Copyright KADIBIA BEAUTY 2024 - Your Beauty Care Partner</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;